module.exports = "/_next/static/resources/array-9b8cd96ef371325b8d7f10101a4bc54f.jpg";